import { atom } from 'jotai';
import { pendingQueue } from 'shared/utils/pending-queue';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';

export interface IArticleGPTInfo {
  title: string;
  description: string;
  supplements: string;
}

type TArticleGPTInfoStore = Record<string, IArticleGPTInfo | undefined>;

export const $ArticleGPTInfoStore = atom({} as TArticleGPTInfoStore);
$ArticleGPTInfoStore.debugLabel = '$ArticleGPTInfoStore';

export const $ArticleGPTInfo = safeAtomFamily((groupId: string) => {
  const a = atom<IArticleGPTInfo | Promise<IArticleGPTInfo>, [IArticleGPTInfo | Promise<IArticleGPTInfo>], void>(
    (get) => {
      const data = get($ArticleGPTInfoStore)[groupId];
      if (!data) {
        // eslint-disable-next-line @typescript-eslint/no-throw-literal
        throw new Promise((resolve) => pendingQueue.push(() => resolve('$ArticleGPTInfo placeholder')));
      }
      return data;
    },
    (get, set, next) => {
      const old = get($ArticleGPTInfoStore);
      set($ArticleGPTInfoStore, { ...old, [groupId]: next as IArticleGPTInfo });
    },
  );

  a.debugLabel = `$ArticleGPTInfo+${encodeURIComponent(groupId)}`;

  return a;
});
